// src/lib/api.js
// Small API helper that reads Vite env var VITE_BACKEND_URL
// If not provided, will use relative URLs (same origin)

const BASE_URL = import.meta.env.VITE_BACKEND_URL || '';
const MODE = import.meta?.env?.MODE || 'development';
const API_BASE = (BASE_URL || '').replace(/\/$/, ''); // strip trailing slash

// In production builds on static hosting, missing BACKEND_URL will lead to
// same-origin /api calls that 405. Surface a clear warning for easier setup.
if (MODE === 'production' && !API_BASE) {
  // eslint-disable-next-line no-console
  console.warn(
    '[api] VITE_BACKEND_URL is not set. Your production build will call same-origin /api, which will fail on static hosting. Set VITE_BACKEND_URL in .env.production to your backend base URL.'
  );
}

async function http(url, options = {}) {
  const { timeoutMs = 12000, ...rest } = options || {};
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(new Error('Request timed out')), timeoutMs);

  const res = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...(rest.headers || {}),
    },
    signal: controller.signal,
    ...rest,
  }).finally(() => clearTimeout(id));
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${text || res.statusText}`);
  }
  const ct = res.headers.get('content-type') || '';
  return ct.includes('application/json') ? res.json() : res.text();
}

export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${p}`;
}

export async function getDrivers() {
  return http(apiUrl('/api/drivers'));
}

export async function saveDrivers(drivers) {
  return http(apiUrl('/api/drivers'), {
    method: 'POST',
    body: JSON.stringify({ drivers }),
  });
}

export async function getRecords() {
  return http(apiUrl('/api/records'));
}

export async function saveRecords(records) {
  return http(apiUrl('/api/records'), {
    method: 'POST',
    body: JSON.stringify({ records }),
  });
}

export async function sendContact(payload, options = {}) {
  return http(apiUrl('/api/contact'), {
    method: 'POST',
    body: JSON.stringify(payload),
    ...options,
  });
}

export async function getDriverMeta() {
  return http(apiUrl('/api/driverMeta'));
}

export async function saveDriverMeta(meta) {
  return http(apiUrl('/api/driverMeta'), {
    method: 'POST',
    body: JSON.stringify({ meta }),
  });
}